export default __webpack_public_path__ + "static/media/beeer_tan.b1cb5708.png";